module.exports = __webpack_public_path__ + "static/media/landingBanner-mobile.96043c01.png";